"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APISDKFactory = void 0;
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var createAPISDKV2_1 = __importDefault(require("./createAPISDKV2"));
var fakeApiServiceFactory_1 = __importDefault(require("./fakeApiServiceFactory"));
__exportStar(require("./types"), exports);
var APISDKFactory = /** @class */ (function () {
    function APISDKFactory() {
        this.create = createAPISDKV2_1.default;
        this.fakeApiServiceFactory = fakeApiServiceFactory_1.default;
    }
    APISDKFactory = __decorate([
        CommonService_decorator_1.CommonService('APISDKFactory')
    ], APISDKFactory);
    return APISDKFactory;
}());
exports.APISDKFactory = APISDKFactory;
//# sourceMappingURL=APISDK.factory.js.map